"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.JsonComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class JsonComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    const {
      open = []
    } = props;
    this.state = {
      open: open
    };
    this.toggle = this.toggle.bind(this);
    this.isOpen = this.isOpen.bind(this);
    this.Node = this.Node.bind(this);
  }
  isObject(data) {
    return Object.prototype.toString.call(data) === '[object Object]';
  }
  isOpen(namespace) {
    return this.state.open.includes(namespace);
  }
  toggle(e) {
    const open = [...this.state.open];
    const {
      currentTarget
    } = e;
    if (currentTarget) {
      const namespace = currentTarget.getAttribute('namespace');
      console.log(namespace); // eslint-disable-line
      if (this.isOpen(namespace)) {
        const index = open.findIndex(v => v === namespace);
        open.splice(index, 1);
      } else {
        open.push(namespace);
      }
      this.setState({
        open
      });
    }
  }
  Node(props) {
    const {
      Node
    } = this;
    const {
      data,
      namespace = [],
      name
    } = props;
    let ObjectComponent;
    let ValueComponent;
    const isObject = this.isObject(data);
    const isArray = Array.isArray(data);
    if (isObject) {
      ObjectComponent = Object.keys(data).map(key => {
        const thisnamespace = [...namespace, key];
        return /*#__PURE__*/React.createElement(Node, {
          key: thisnamespace.join('.'),
          namespace: thisnamespace,
          name: key,
          data: data[key]
        });
      });
    } else if (isArray) {
      ObjectComponent = data.map((entry, i) => {
        const thisnamespace = [...namespace, i];
        return /*#__PURE__*/React.createElement(Node, {
          key: thisnamespace.join('.'),
          namespace: thisnamespace,
          name: i,
          data: entry
        });
      });
    } else if (data === null) {
      // eslint-disable-line
      ValueComponent = 'null';
    } else if (data === undefined) {
      // eslint-disable-line
      ValueComponent = 'undefined';
    } else {
      ValueComponent = data.toString();
    }
    const collapsable = (isObject || isArray) && namespace.length > 0 && ObjectComponent.length > 0;
    const isCollapsed = !this.isOpen(namespace.join('.'));
    let symbol = ' ';
    if (isCollapsed && collapsable) {
      symbol = '+';
    } else if (collapsable) {
      symbol = '-';
    }
    const label = /*#__PURE__*/React.createElement("button", {
      style: {
        border: 'none',
        fontWeight: 'bold',
        backgroundColor: 'transparent'
      }
      // eslint-disable-next-line react/no-unknown-property
      ,
      namespace: namespace.join('.'),
      onClick: this.toggle
    }, symbol, name);
    if (isCollapsed && collapsable) {
      ValueComponent = /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#999'
        }
      }, " ", ObjectComponent.length, " ");
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: '20px',
        borderLeft: 'solid 1px #bbb'
      }
    }, /*#__PURE__*/React.createElement("span", null, label, ": "), isObject && /*#__PURE__*/React.createElement("span", null, '{'), isArray && /*#__PURE__*/React.createElement("span", null, '['), !ValueComponent && ObjectComponent, ValueComponent, isObject && /*#__PURE__*/React.createElement("span", null, '}'), isArray && /*#__PURE__*/React.createElement("span", null, ']'));
  }
  render() {
    const {
      Node
    } = this;
    return /*#__PURE__*/React.createElement(Node, this.props);
  }
}
exports.JsonComponent = JsonComponent;
JsonComponent.propTypes = {
  open: _propTypes.default.array,
  namespace: _propTypes.default.array,
  name: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  data: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool, _propTypes.default.array, _propTypes.default.object])
};
var _default = exports.default = JsonComponent;